import { setSubmitting } from 'src/redux/modules/webpage/loading';

import { API_METHOD, authApiClient } from '../../api';

// 액션 타입
const LOAD_REVIEW_GROUP = 'reviewGroup/LOAD_REVIEW_GROUP';

// 액션 생성함수
const loadReviewGroup = reviewGroup => ({ type: LOAD_REVIEW_GROUP, reviewGroup });

export const handleLoadReviewGroup = id => {
  return async dispatch => {
    try {
      const response = await authApiClient(API_METHOD.GET, `review/group/${id}`);
      dispatch(loadReviewGroup(response.data.result));
    } catch (e) {
      alert(e.message);
    }
  };
};

export const handleCreateReviewGroup = body => {
  return async dispatch => {
    try {
      dispatch(setSubmitting(true));
      const response = await authApiClient(API_METHOD.POST, 'review/group', body);
      dispatch(loadReviewGroup(response.data.result));
      return response.data.result;
    } catch (e) {
      alert(e.message);
    } finally {
      dispatch(setSubmitting(false));
    }
  };
};

export const handleUpdateReviewGroup = (id, body) => {
  return async dispatch => {
    try {
      dispatch(setSubmitting(true));
      const response = await authApiClient(API_METHOD.PATCH, `review/group/${id}`, body);
      dispatch(loadReviewGroup(response.data.result));
      return response.data.result;
    } catch (e) {
      alert(e.message);
    } finally {
      dispatch(setSubmitting(false));
    }
  };
};

export const handleDeleteReviewGroup = id => {
  return async dispatch => {
    try {
      dispatch(setSubmitting(true));
      await authApiClient(API_METHOD.DELETE, `review/group/${id}`);
    } catch (e) {
      alert(e.message);
    } finally {
      dispatch(setSubmitting(false));
    }
  };
};

// 초기 상태 선언
const initialState = {};

// 리듀서 선언
export default function reviewGroup(state = initialState, action) {
  switch (action.type) {
    case LOAD_REVIEW_GROUP: {
      return action.reviewGroup;
    }
    default:
      return state;
  }
}
